export const NAME = "crm";

export const FORM_EDIT_CLIENT = "FORM_EDIT_CLIENT";

// Entity
export const ENTITY_CLIENT_CONTRACTS_METADATA = `${NAME}/ENTITY_CLIENT_CONTRACTS_METADATA`;
export const ENTITY_CLIENT_CONTRACTS_OVERVIEW = `${NAME}/ENTITY_CLIENT_CONTRACTS_OVERVIEW`;
